import { Col, Typography } from "antd";
import styled from "styled-components";

export const Wrapper = styled.div`
  margin: 0px;
  display: flex;
  align-items: flex-end;

  .ant-input-group-wrapper.ant-input-search {
    width: 270px;
  }

  .button {
    padding: 0;
    
  }
`;

export const StyledSearch = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

export const StyledText = styled(Typography.Text)`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

export const FilterWrapper = styled(Col)<{
  $isActive: boolean;
  $isDirectionReversed: boolean;
}> `
  cursor: pointer;

  > .ant-row > .ant-btn-link > span {
    font-weight: 500;
    line-height: 24px;
    color: ${(props) => (props.$isActive ? "#1677ff" : "#434343")};
  }

  svg {
    color: ${(props) => (props.$isActive ? "#1677ff" : "#434343")};
    width: ${(props) => (props.$isActive ? "14px" : 0)};
    margin-bottom: 6px;
    transform: ${(props) =>
      props.$isDirectionReversed ? "rotate(180deg)" : ""};
    transition: transform 0.3s, width 0.1s;
  }
`;
